module.exports = __webpack_public_path__ + "img/B.3f715d63.svg";